import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendService} from '@tg4/http-infrastructure/dist/src';
import {Observable} from 'rxjs';
import {AuthService} from 'src/app/shared/services/auth.service';
import {SharedService} from 'src/app/shared/services/shared.service';
import {AggregatedHeadEvaluated, HeadEvaluated} from './_interfaces/head-evaluated.interface';
import {HeadEvaluationRecords} from './_interfaces/head-evaluation-record';

@Injectable()
export class HeadEvaluationService {

    constructor(private _httpService: BackendService,
                private authService: AuthService,
                private http: HttpClient,
                private _sharedService: SharedService) {
    }

    public getHeadEvaluations(cycleId: number, userIndex: number, pageSize: number): Observable<any> {
        return this._httpService.get('getHeadEvaluations', [], [
            {'name': 'cycleId', 'value': cycleId as any},
            {'name': 'userIndex', 'value': userIndex as any},
            {'name': 'pageSize', 'value': pageSize as any},
        ]);
    }

    public saveHeadEvaluation(evaluation: AggregatedHeadEvaluated): Observable<any> {
        return this._httpService.post('saveHeadEvaluation', evaluation);
    }

    public reopenHeadEvaluation(evaluation: AggregatedHeadEvaluated): Observable<any> {
        return this._httpService.put('reopenHeadEvaluation', evaluation);
    }
}
